const commonActions = [
  { action: "saveData", value: "timeOut", type: "eventType" },
  { action: "sendEvent", value: "new", type: "main" },
  {
    action: "adjustTeamValue",
    value: 1,
    options: { currentEntity: true, item: "timeouts" },
  },
  { action: "popStash", type: "main" },
  {
    action: "nextState",
    value: null,
    type: "primary",
  },
  { action: "processInserts", value: "all", type: "inserts" },
];

export const SimpleFreeThrowTimeout = {
  name: "simple-freethrow-timeout",
  component: "MainPanel",
  layout: "main-panel large padded align-center",
  mode: "visible",
  text: "timeout.select",
  allowFlag: true,
  allowCancel: true,
  showOn: [{ state: "primary", value: "simple-freethrow-timeout", operator: "is" }],
  children: [
    {
      name: "team-0-timeout",
      component: "TypeButton",
      layout: "match-button",
      mode: "enable",
      text: { team: "name" },
      showOn: [true],
      options: { team: 0 },
      actionGroups: [
        {
          actions: commonActions,
          conditions: [],
        },
      ],
      startEvent: true,
      startPlay: true,
    },
    {
      name: "team-1-timeout",
      component: "TypeButton",
      layout: "match-button",
      mode: "enable",
      text: { team: "name" },
      showOn: [true],
      options: { team: 1 },
      actionGroups: [
        {
          actions: commonActions,
          conditions: [],
        },
      ],
      startEvent: true,
      startPlay: true,
    },
  ],
};
